import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import { normalizeRole } from '../utils/roleUtils';

// Sayfa bazlı rol erişim haritası
const routePermissions = {
    '/users': ['admin'],
    '/mobile-announcements': ['admin'],
    '/notifications': ['admin'],
    '/company-tasks': ['admin', 'boss'],
    '/reconciliations': ['admin', 'boss'],
    '/collection-reports': ['admin', 'boss'],
    '/shipment-reports': ['admin', 'boss'],
    '/collections': ['admin', 'boss', 'staff'],
    '/aging': ['admin', 'boss', 'staff'],
    '/files': ['admin', 'boss', 'staff'],
    '/shipments': ['admin', 'boss', 'staff', 'shipment_staff'],
    '/ready-to-ship': ['admin', 'boss', 'staff', 'shipment_staff'],
    '/dashboard': ['admin', 'boss', 'staff'],
};

const PrivateRoute = ({ children }) => {
    const { user, loading, isAuthenticated } = useContext(AuthContext);
    const location = useLocation();
    const normalizedRole = normalizeRole(user?.role);

    if (loading) {
        return null;
    }

    if (!isAuthenticated || !user) {
        return <Navigate to="/login" />;
    }

    // Sayfa için tanımlı rol kısıtlaması varsa kontrol et
    const allowedRoles = routePermissions[location.pathname];
    if (allowedRoles && normalizedRole && !allowedRoles.includes(normalizedRole)) {
        // Yetkisiz kullanıcıyı uygun ana sayfasına yönlendir
        if (normalizedRole === 'shipment_staff') {
            return <Navigate to="/shipments" />;
        }
        return <Navigate to="/dashboard" />;
    }

    // Token ve yetki varsa istenen sayfayı göster
    return children;
};

export default PrivateRoute;
